import React, { Suspense } from 'react';
import logo from './logo.svg';
import './App.scss';
import "bootstrap/dist/js/bootstrap.bundle.min.js";


import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './home/home';
import Login from './admin/login';
import Contact from './contacts/contact';
import About from './about/about';
import Dashboard from './admin/dashboard';
import ListTrip from './admin/listTrips';
import ListBlog from './blogs/list-blogs';
import BlogSingle from './blogs/blog-single';
import CarRental from './cars/car-rental';
import CarRentalDetail from './cars/car-single';
import FAQ from './faq/faq';
import Trips from './trips/trips';
import TripSingle from './trips/trip-single';
import Promotions from './promotions/list-promotions';
import SinglePromotion from './promotions/promotion-single';
import RequestTicket from './tickets/request-ticket';
import Terms from './terms/terms';
import Ticket from './tickets/ticket';
import SchengenVisa from './visas/schengen-visa';
import ListClient from './admin/listClients';
import ListCars from './admin/listCars';
import ListRequestVisa from './admin/listRequestVisas';
import ListRequestRentCar from './admin/listRequestRentCar';
import ListBookingTours from './admin/listBookingTours';
import ListPromotion from './admin/listPromotion';
import ListTicket from './admin/listTicket';
import ListBookingPromotions from './admin/listBookingPromotion';
import ListBlogs from './admin/listBlog';
import AddBlog from './admin/addBlog';
import ListInvoices from './admin/listInvoices';
import AddTour from './admin/addTour';
import AddPromotion from './admin/addPromotion';
import AddClient from './admin/addClient';
import ApplicationVisaForm from './visas/visa-application-form';
import TrackVisa from './visas/track-visa';
import PageReviews from './reviews/page-reviews';
import LoginCustomer from './authentication/login-customer';
import RegisterCustomer from './authentication/register-customer';
import InfoSchengen from './visas/info-shengen';
import DummyTicket from './visas/dummy-ticket';
import DashboardCustomer from './account_customer/dashboard_customer';
import MyFlights from './account_customer/my-flights';
import MyTrips from './account_customer/my-trips';
import MyRentCars from './account_customer/my-rent-cars';
import VisaSearchResults from "./visas/VisaSearchResults";
import Insurance from "./visas/visa-insurance";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditBlog from './admin/editBlog';
import AddCar from './admin/addCar';
import EditCar from './admin/editCar';
import EditClient from './admin/editClient';
import EditTour from './admin/editTour';
import DetailsRequestRentCar from './admin/detailsRequestRentCar';
import DetailsBookingTour from './admin/detailsBookingTour';
import DetailsBookingPromotion from './admin/detailsBookingPromotion';
import SearchVisa from './visas/search-visa';
import MyRequestVisa from './account_customer/my-request-visa';
import ListPacks from './admin/listPacks';
import AddVisaPack from './admin/addPack';
import EditVisaPack from './admin/editPack';
import AddInvoice from './admin/addInvoice';
import EditInvoice from './admin/editInvoice';
import EditPromotion from './admin/editPromotion';
import ListFlightRequests from './admin/listFlightRequest';
import TermCondition from './conditions/TermCondition';
import PaymentGuidelines from './conditions/PaymentGuidelines';
import PrivacyPolicy from './conditions/PrivacyPolicy';
import LegalDisclaimer from './conditions/LegalDisclaimer';
import VisaPageLayout from './visas/visa-page-layout';
import VisaOmanPage from './visas/visa-oman';
import VisaUaePage from './visas/visa-uae';
import VisaKsaPage from './visas/visa-ksa';
import VisaBahrainPage from './visas/visa-bahrain';
import VisaKuwaitPage from './visas/visa-kuwait';
import VisaQatarPage from './visas/visa-qatar';
import VisaThailandPage from './visas/visa-thailand';
import VisaIndiaPage from './visas/visa-india';
import VisaArmeniaPage from './visas/visa-armenia';
import VisaSchengenPage from './visas/visa-schengen';
import VisaUsaPage from './visas/visa-usa';
import VisaCanadaPage from './visas/visa-canada';
import ManageCountries from './admin/ManageCountries';
import AdminLayout from './admin/AdminLayout';
import ListDummyTicketRequests from './admin/listDummyTicketRequests';

import { WhatsAppProvider } from './components/WhatsAppContext';
import { SupportProvider } from './components/SupportContext';
import VisaApplicationDetail from './admin/VisaApplicationDetail';
import BookingPage from './trips/BookingPage';
import NotFound from './notFound/NotFound'; 
import NotificationsPage from "./admin/notificationsPage";
import AuthCallback from './components/AuthCallback';
import BookingConfirmation from './cars/BookingConfirmation';
import ForgotPassword from './authentication/ForgotPassword';
import ListActivities from './admin/listActivities';
import Services from './services/Services';
import ReligiousTourism from './services/religious-tourism';
import CorporateTravel from './services/corporate-travel';
import AirlineReservations from './services/airline-reservations';
import MeetGreet from './services/meet-greet';
import UaeVisa from './services/uae-visa';
import CruiseHolidays from './services/cruise-holidays';
import InboundHolidays from './services/inbound-holidays';
import GlobalVisa from './services/global-visa';
import WorldwideHotels from './services/worldwide-hotels';
import EducationalTrips from './services/educational-trips';
import Mice from './services/mice';
import RailEurope from './services/rail-europe';
import ProtectedRoute from './admin/ProtectedRoute';
import AddActivity from './admin/AddActivity';
import EditActivity from './admin/EditActivity';
import ActivityDetail from './services/ActivityDetail';
import CalendarBookingCars from './admin/calendarBookingCars';
import ListActivityBookings from './admin/listActivityBooking';
import CustomerProtectedRoute from "./components/CustomerProtectedRoute";
import AuthPublicRoute from "./components/AuthPublicRoute";

function App() {

  const location = useLocation();

  const isHomePage = location.pathname === '/';

  if (isHomePage) {
    return (
      <WhatsAppProvider>
        <SupportProvider>
          <Routes>
            <Route path="/" element={<Home />} />
           
          </Routes>
        </SupportProvider>
      </WhatsAppProvider>
    );
  }
  
  return (
    <Suspense fallback={<div>Chargement…</div>}>

<ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <Routes>
        {/* Redirige / vers /home si tu veux */}
        <Route path="/" element={<Navigate to="/" replace />} />
         <Route path="*" element={<NotFound />} />
        
        {/* Affiche la page Home pour /home */}
        <Route path="/visa-oman" element={<VisaOmanPage />} />
        <Route path="/visa-uae" element={<VisaUaePage />} />
        <Route path="/visa-ksa" element={<VisaKsaPage />} />
        <Route path="/visa-bahrain" element={<VisaBahrainPage />} />
        <Route path="/visa-kuwait" element={<VisaKuwaitPage />} />
        <Route path="/visa-qatar" element={<VisaQatarPage />} />
        <Route path="/visa-thailand" element={<VisaThailandPage />} />
        <Route path="/visa-india" element={<VisaIndiaPage />} />
        <Route path="/visa-armenia" element={<VisaArmeniaPage />} />
        <Route path="/visa-schengen" element={<VisaSchengenPage />} />
        <Route path="/visa-usa" element={<VisaUsaPage />} />
        <Route path="/visa-canada" element={<VisaCanadaPage />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/visa-page" element={<VisaPageLayout countryName={''} flagEmoji={''} heroEyebrow={''} heroImage={''} heroTitleLead={''} heroTitleHighlight={''} heroSubtitle={''} trustStats={[]} plans={[]} requirements={[]} goodToKnow={[]} steps={[]} faqs={[]} ctaSubtitle={''} />} />
        <Route path="/login-admin" element={<Login />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/blogs" element={<ListBlog />} />
        <Route path="/car-rent" element={<CarRental />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/detail-promotion/:id" element={<SinglePromotion />} />
        <Route path="/detail-blog/:id" element={<BlogSingle />} />

        <Route path="/detail-trip/:id" element={<TripSingle />} />
        <Route path="/request-ticket" element={<RequestTicket />} />
        <Route path="/schengen-visa" element={<SchengenVisa />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/search-visa" element={<SearchVisa />} /> 
        <Route path="/flights" element={<Ticket />} />
        <Route path="/terms-and-conditions" element={<TermCondition />} />
        <Route path="/payment-guidelines" element={<PaymentGuidelines />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
        <Route path="/car-rental/confirmation/:id" element={<BookingConfirmation />} />

        <Route 
                    path="/forgot-password" 
                    element={
                        <AuthPublicRoute>
                            <ForgotPassword />
                        </AuthPublicRoute>
                    } 
                />
        

       
        <Route path="/booking-trip" element={<BookingPage />} />
        <Route path="/car-rental/:id" element={<CarRentalDetail />} />
        

        

        <Route path="/visa-application" element={<ApplicationVisaForm />} />
        <Route path="/track-application" element={<TrackVisa />} />
        <Route path="/reviews" element={<PageReviews />} />

        <Route 
                    path="/login" 
                    element={
                        <AuthPublicRoute>
                            <LoginCustomer />
                        </AuthPublicRoute>
                    } 
                />

        <Route path="/auth/callback" element={<AuthCallback />} />

        <Route 
                    path="/sign-up" 
                    element={
                        <AuthPublicRoute>
                            <RegisterCustomer />
                        </AuthPublicRoute>
                    } />

        <Route path="/info-shengen" element={<InfoSchengen />} />
        <Route path="/dummy-ticket" element={<DummyTicket />} />
        <Route  path="/my-dashboard" 
                    element={
                        <CustomerProtectedRoute>
                            <DashboardCustomer />
                        </CustomerProtectedRoute>
                    } />
         <Route  path="/my-flight" 
                    element={
                        <CustomerProtectedRoute>
                            <MyFlights />
                        </CustomerProtectedRoute>
                    }/>

         <Route  path="/my-trips" 
                    element={
                        <CustomerProtectedRoute>
                            <MyTrips />
                        </CustomerProtectedRoute>
                    }/>

        <Route  path="/my-rent-cars" 
                    element={
                        <CustomerProtectedRoute>
                            <MyRentCars />
                        </CustomerProtectedRoute>
                    }/>

        <Route  path="/my-request-visa" 
                    element={
                        <CustomerProtectedRoute>
                            <MyRequestVisa />
                        </CustomerProtectedRoute>
         }/>


        <Route path="services" element={<Services />} />
        <Route path="services/religious-tourism" element={<ReligiousTourism />} />  
        <Route path="/services/corporate-travel" element={<CorporateTravel />} />
        <Route path="/services/airline-reservations" element={<AirlineReservations />} />
        <Route path="/services/meet-greet" element={<MeetGreet />} />
        <Route path="/services/uae-visa" element={<UaeVisa />} />
        <Route path="/services/cruise-holidays" element={<CruiseHolidays />} />
        <Route path="/services/inbound-holidays" element={<InboundHolidays />} />
        <Route path="/services/global-visa" element={<GlobalVisa />} />
        <Route path="/services/worldwide-hotels" element={<WorldwideHotels />} />
        <Route path="/services/educational-trips" element={<EducationalTrips />} />
        <Route path="/services/mice" element={<Mice />} />
        <Route path="/services/car-rental" element={<CarRental />} />
        <Route path="/services/rail-europe" element={<RailEurope />} />
        

        <Route path="/admin/edit-client/:id" element={<EditClient />} /> 
 
        <Route path="/admin/details-booking-trip/:id" element={<DetailsBookingTour />} /> 
        <Route path="/admin/details-booking-promotion/:id" element={<DetailsBookingPromotion />} /> 
        <Route path="/visa-results" element={<VisaSearchResults />} />

        <Route path="/activities/:id" element={<ActivityDetail />} />
        

        

        

        {/* Si quelqu’un tape une URL inexistante */}
        <Route path="*" element={<div>404 - Page non trouvée</div>} />

        <Route path="/admin" element={<ProtectedRoute requiredRole="admin" />}>
         <Route element={<AdminLayout />}>
           <Route path="list-countries" element={<ManageCountries />} />
           <Route path="list-packs" element={<ListPacks />} />
           <Route path="add-pack" element={<AddVisaPack />} />
           <Route path="details-visa-application/:id" element={<VisaApplicationDetail />} />
           <Route path="add-tour" element={<AddTour />} />
           <Route path="list-trips" element={<ListTrip />} />
           <Route path="list-blog" element={<ListBlogs />} />
           <Route path="add-blog" element={<AddBlog />} />
           <Route path="edit-blog/:id" element={<EditBlog />} /> 
           <Route path="list-ticket" element={<ListTicket />} />
           <Route path="list-flight-requests" element={<ListFlightRequests />} />
           <Route path="edit-pack/:id" element={<EditVisaPack />} />
           <Route path="list-request-visas" element={<ListRequestVisa />} />
           <Route path="list-clients" element={<ListClient />} />
           <Route path="edit-tour/:id" element={<EditTour />} />
           <Route path="list-booking-tour" element={<ListBookingTours />} />
           <Route path="list-promotion" element={<ListPromotion />} />
           <Route path="add-promotion" element={<AddPromotion />} />
           <Route path="list-booking-promotion" element={<ListBookingPromotions />} />
           <Route path="list-cars" element={<ListCars />} />
           <Route path="add-car" element={<AddCar />} /> 
           <Route path="list-request-rent-car" element={<ListRequestRentCar />} />
           <Route path="list-invoices" element={<ListInvoices />} />
           <Route path="add-invoice" element={<AddInvoice />} />
           <Route path="edit-invoice/:id" element={<EditInvoice />} />
           <Route path="add-client" element={<AddClient />} />
           <Route path="edit-promotion/:id" element={<EditPromotion />} />
           <Route path="dashboard" element={<Dashboard />} />
           <Route path="list-dummy-tickets" element={<ListDummyTicketRequests />} />
           <Route path="notifications" element={<NotificationsPage />} />
           <Route path="details-rent-car/:id" element={<DetailsRequestRentCar />} /> 
           <Route path="list-activities" element={<ListActivities />} />  
           <Route path="add-activity" element={<AddActivity />} /> 
           <Route path="edit-activity/:id" element={<EditActivity />} /> 
           <Route path="edit-car/:id" element={<EditCar />} /> 
           <Route path="calendar-booking-cars" element={<CalendarBookingCars />} /> 
           <Route path="list-booking-activites" element={<ListActivityBookings />} /> 
           
           

        </Route>
        </Route>



      </Routes>
     
    </Suspense>

    
  );
}

export default App;
